<div class="field-container">
    <label class="label">{{ label | translate }}</label>

    <label class="field-readonly">{{ value }}</label>
</div>
